export const equipmentStatusTranslation = {
  enabled: 'Ativo',
  disabled: 'Inativo',
  blocked: 'Bloqueado',
  awaiting_card: 'Aguardando cartão'
};
